import react, { useEffect } from "react"
import "./admin.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectSessionId, selectAdminToken, setSession } from "./sessionSlice";
import AdminTour from "./tour/AdminTour";

function Admin({children}){
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentSessionId = useSelector(selectSessionId);
  const adminToken = useSelector(selectAdminToken);

  // The admin token persists in localStorage (see sessionSlice.js) so it survives across tabs —
  // but that means a genuinely NEW session/organization passed in the URL (e.g. a fresh "create
  // new hunt" link) would otherwise be silently ignored in favor of whatever was saved from a
  // previous visit. Only overwrite when the URL actually names a different session than the one
  // already active, so this doesn't refire on every refresh of a deep admin page.
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const sessionIdFromUrl = searchParams.get('sessionId');
    const organizationIdFromUrl = searchParams.get('organizationId');
    if (!sessionIdFromUrl || !organizationIdFromUrl) return;
    const urlToken = `${sessionIdFromUrl}&${organizationIdFromUrl}`;
    if (urlToken !== adminToken) {
      dispatch(setSession({ sessionId: sessionIdFromUrl, organizationId: organizationIdFromUrl }));
    }
  }, [location.search, adminToken, dispatch]);

 const raw = location.pathname;
 const cleaned = raw.endsWith("/") && raw !== "/" ? raw.slice(0, -1) : raw;
 const isRootAdmin = cleaned === "/admin";
 const isSuperAdmin = currentSessionId === 'admin';

      const redirectGameSession = () => {
        try {
          const stored =
            sessionStorage.getItem("userData") || localStorage.getItem("userData");
          if (!stored) return;
          const parsed = JSON.parse(stored);
          const gameId = parsed?.gameId;
          if (!gameId) return;
          window.location.href = `${process.env.REACT_APP_BASE_URL}/active-games/${gameId}`;
        } catch {
          /* ignore bad storage */
        }
      };

      return <div className="admin-background">
       <div className="header-admin">
        {/* {!isRootAdmin && (
          <div className="back-button-holder">
              <button
                className="back-button"
                onClick={() => navigate(-1)}
              >
              <i class="fa-solid fa-arrow-left"></i> Back
              </button>
          </div>
        )} */}

         <div class="brand-logo-and-game-holder">
          <div className="brand-logo-holder" onClick={()=>{window.location.href = process.env.REACT_APP_BASE_URL;}}>
          <img src="/admin/play.png" className="brand-logo"/>{isSuperAdmin && " SUPERADMIN"}
         </div>
         <div onClick={()=>{redirectGameSession()}}>Treasure Game </div>

         </div>


         <div className="user">
            <img src="/admin/user.png"/>
         </div>
       </div>
       {children}
       <AdminTour />
      </div>
}

export default Admin;
